import { render, staticRenderFns } from "./ArtistJournalSearch.vue?vue&type=template&id=70f1e7c0&scoped=true"
import script from "./ArtistJournalSearch.vue?vue&type=script&lang=js"
export * from "./ArtistJournalSearch.vue?vue&type=script&lang=js"
import style0 from "./ArtistJournalSearch.vue?vue&type=style&index=0&id=70f1e7c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f1e7c0",
  null
  
)

export default component.exports